import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import { EventPdvSaleProductReport } from '@/model/EventPdvSaleProductReport';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import { ReportControllerProps } from '../../types';
import { SaleProductPdvContent } from './ui';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
}

export const SaleProductPdv: React.FC<StateProps> = ({
  reportController,
  setState,
}): JSX.Element => {
  const { eventId, singleEvent } = reportController;
  const [pdvs, setPdvs] = useState<EventPdvSaleProductReport[]>([]);
  const [allPdvs, setAllPdvs] = useState<EventPdvSaleProductReport[]>([]);

  const [pdvId, setPdvId] = useState<string>('');
  const [productName, setProductName] = useState<string>('');

  const handleGetSaleProducts = async (
    filterPdv = pdvId,
    filterProduct = productName,
  ): Promise<void> => {
    try {
      setState(States.loading);

      const params = new URLSearchParams();
      params.append('singleEvent', String(singleEvent));
      if (filterPdv) {
        params.append('pdvId', filterPdv);
      }
      if (filterProduct.trim()) {
        params.append('productName', filterProduct.trim());
      }

      const { data } = await api.get<EventPdvSaleProductReport[]>(
        `event/report/${eventId}/sale-product/pdv?${params.toString()}`,
      );
      if (data) {
        setPdvs(data);
        if (allPdvs.length === 0) {
          setAllPdvs(data);
        }
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const handleClearFilter = (): void => {
    setPdvId('');
    setProductName('');
    handleGetSaleProducts('', '');
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, [singleEvent]);

  return (
    <SaleProductPdvContent
      pdvs={pdvs}
      allPdvs={allPdvs}
      pdvId={pdvId}
      productName={productName}
      onChangePdvId={setPdvId}
      onChangeProductName={setProductName}
      onFilter={() => handleGetSaleProducts()}
      onClearFilter={handleClearFilter}
    />
  );
};
